import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../shared/Icon';

const CustomToolbar = ({ label, onNavigate, onView, view, centerLabel = null, isAllCenters = false }) => {
  const { t } = useTranslation();

  const navigate = action => {
    onNavigate(action);
  };

  const viewNames = {
    month: t('CALENDAR.month', 'Mês'),
    week: t('CALENDAR.week', 'Semana'),
    day: t('CALENDAR.day', 'Dia'),
    agenda: t('CALENDAR.agenda', 'Agenda'),
  };

  return (
    <div className="rbc-toolbar flex items-center justify-between mb-4">
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          type="button"
          onClick={() => navigate('PREV')}
          className="flex items-center justify-center w-10 h-10 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          aria-label={t('CALENDAR.previous', 'Anterior')}
        >
          <Icon name="chevron-left" size="sm" />
        </button>
        <button
          type="button"
          onClick={() => navigate('NEXT')}
          className="flex items-center justify-center w-10 h-10 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          aria-label={t('CALENDAR.next', 'Próximo')}
        >
          <Icon name="chevron-right" size="sm" />
        </button>

        <button
          type="button"
          onClick={() => navigate('TODAY')}
          className="px-4 h-10 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium text-sm"
        >
          {t('CALENDAR.today', 'Hoje')}
        </button>
      </div>

      <div className="flex-1 text-center min-w-0 px-2">
        <span className="text-lg font-semibold text-gray-900 block">{label}</span>
        {centerLabel && (
          <p className="text-sm text-gray-500 mt-0.5 truncate" title={centerLabel}>
            {t('CALENDAR.viewingCenter', 'Calendario di')}{' '}
            <span className={`font-semibold ${isAllCenters ? 'text-gray-700' : 'text-feel-primary'}`}>{centerLabel}</span>
          </p>
        )}
      </div>

      <div className="flex items-center gap-1 flex-shrink-0">
        {['month', 'week', 'day'].map(name => (
          <button
            key={name}
            type="button"
            onClick={() => onView(name)}
            className={`px-4 h-10 font-medium text-sm transition-colors rounded-lg ${
              view === name ? 'bg-gray-600 text-white' : 'bg-gray-400 text-white hover:bg-gray-500'
            }`}
          >
            {viewNames[name]}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomToolbar;
